import utils from './utils';

import auth from './auth';
import campaigns from './campaigns';
import sales from './sales';

const index = {
  utils,

  auth,
  campaigns,
  sales,
};

export default index;